var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLupaDiminui(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.999,
    height: 20,
    viewBox: "0 0 19.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 19.999,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.999,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M2.62365723 1.96331787c3.09912109-2.7492981 7.80395507-2.6069336 10.73120117.32467651 2.67175293 2.68103028 3.04467773 6.88891602.88598633 9.99801636.3137207.06515503.60168457.2201233.82897949.44598389l4.44299316 4.44500732c.64550782.64562989.64550782 1.69238282 0 2.3380127-.64562988.64559936-1.69238281.64559936-2.3380127 0l-4.44299316-4.44302368c-.22644043-.22695923-.38171386-.51504517-.44689941-.8289795-3.40136719 2.36520386-8.0567627 1.6697693-10.6184082-1.58618164C-.8951416 9.40087891-.47558594 4.71258545 2.62365723 1.96331787zm1.069458 9.99057007c2.28137207 2.2814331 5.98022461 2.28146362 8.26171875.00009155h-.0020752c2.27819825-2.28250122 2.27917481-5.97839355.0020752-8.2619934C9.67333984 1.410614 5.9744873 1.41067504 3.69311523 3.69210814c-2.28137207 2.28143311-2.28137207 5.98034668 0 8.26177979z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M11.44982875 8.57171827l7e-7-1.24389648-7-.00000393-7e-7 1.24389648 7 .00000393z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupaDiminui);
export default __webpack_public_path__ + "static/media/lupa_diminui.5505a636668c04db031e691c8f06c91a.svg";
export { ForwardRef as ReactComponent };